import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {OAuthService} from 'angular-oauth2-oidc';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {VtkJob, VtkJobDetail, VtkJobMetrics, VtkLogEntry, VtkPaginatedResponse} from './vtk.types';

@Injectable({providedIn: 'root'})
export class VtkService {

  constructor(private http: HttpClient, private oAuthService: OAuthService) {}

  private headers(orgUrn: string): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${this.oAuthService.getAccessToken()}`,
      'x-castlabs-organization': orgUrn,
    });
  }

  private url(path: string): string {
    return `${environment.VTK_API}${path}`;
  }

  getBundleJobs(orgUrn: string, bundleName: string): Observable<VtkPaginatedResponse<VtkJob>> {
    return this.http.get<VtkPaginatedResponse<VtkJob>>(
      this.url(`/o/${orgUrn}/jb/${encodeURIComponent(bundleName)}/jobs`),
      {headers: this.headers(orgUrn)}
    );
  }

  getJob(orgUrn: string, jobBundle: string, jobId: string): Observable<VtkJobDetail> {
    return this.http.get<VtkJobDetail>(
      this.url(`/o/${orgUrn}/jb/${encodeURIComponent(jobBundle)}/jobs/${jobId}`),
      {headers: this.headers(orgUrn)}
    );
  }

  getJobMetrics(orgUrn: string, jobBundle: string, jobId: string): Observable<VtkJobMetrics> {
    return this.http.get<VtkJobMetrics>(
      this.url(`/o/${orgUrn}/jb/${encodeURIComponent(jobBundle)}/jobs/${jobId}/metrics`),
      {headers: this.headers(orgUrn)}
    );
  }

  getTaskLog(orgUrn: string, jobBundle: string, jobId: string, taskId: number, offset = 0, limit = 1000): Observable<VtkPaginatedResponse<VtkLogEntry>> {
    return this.http.get<VtkPaginatedResponse<VtkLogEntry>>(
      this.url(`/o/${orgUrn}/jb/${encodeURIComponent(jobBundle)}/jobs/${jobId}/tasks/${taskId}/log?limit=${limit}&offset=${offset}`),
      {headers: this.headers(orgUrn)}
    );
  }
}
